import { LogOut, Repeat2 } from "lucide-react";
import { useState } from "react";
import type { Subject } from "../api.js";

export function AccountMenu({
  subject,
  onLogout,
}: {
  subject: Subject;
  onLogout: () => Promise<void>;
}) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  async function leave() {
    setBusy(true);
    try {
      await onLogout();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="account-menu-wrap">
      <button
        type="button"
        className="avatar account-trigger"
        aria-label="打开账号菜单"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {subject.displayName[0]}
      </button>
      {open ? (
        <div className="account-menu" role="menu">
          <div className="account-identity">
            <strong>{subject.displayName}</strong>
            <span>@{subject.username}</span>
          </div>
          <button type="button" role="menuitem" disabled={busy} onClick={leave}>
            <Repeat2 aria-hidden="true" />
            切换账号
          </button>
          <button type="button" role="menuitem" disabled={busy} onClick={leave}>
            <LogOut aria-hidden="true" />
            退出登录
          </button>
        </div>
      ) : null}
    </div>
  );
}
